import Vue from "vue"

Vue.filter("decodeUnicode", (string) => {
    let decoded = string.replace(/\\u[\da-f]{4}/gi,
        function (match) {
            return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
        });
    return decoded
})